const messages = {
  payoutsDescription: "List of paid out BS+ items.",
  paidOut: "paid out",
  makeChoice: "Naredite izbiro",
  seeAll: "Poglej vse",
  clear: "Počisti",
  back: "Nazaj",
  save: "Shrani",
  close: "Zapri",
  of: "Od",
  to: "Do",
  copyrights: "© {date} Bridgestone Solutions. Vse pravice pridržane.",
  pageNotFound: "Stran ni najdena",
  accessDenied: "Dostop zavrnjen",
  search: "Iskanje",
  year: "Leto",
  buttons: {
    loading: "Nalaganje...",
    export: "Izvozi",
    delete: "Izbriši",
    save: "Shrani",
    cancel: "Prekliči",
    next: "Naprej",
    back: "Nazaj",
    skip: "Preskoči",
    send: "Pošlji",
    clear: "Počisti",
    close: "Zapri",
    readNow: "Preberi zdaj",
    pointsList: "Seznam točk",
    more: "Več",
    reportError: "Prijavi napako",
    accept: "Sprejmi",
    download: "Prenesi",
    downloadAll: "Prenesi vse",
    selectAll: "Izberi vse",
    deselectAll: "Prekliči izbor",
    downloadSelection: "Prenesi izbrano",
    dealerInfoDownload: "PRENESI",
    toTheBasket: "V košarico",
    toOrderDelivery: "Nadaljuj na naslov za dostavo",
    discover: "Odkrij",
    newAddress: "Ustvari nov naslov za dostavo",
    selectAddressBtn: "Izberi naslov za dostavo",
    toOrderSummary: "Na pregled naročila",
    placeOrder: "Obligatno naročilo",
    toDashboard: "Na domačo stran",
    newOrder: "Novo naročilo",
    userOrders: "Na vaša naročila",
    toSearch: "Iskanje",
    select: "Izberi",
    moreCustomerNumbers: "+ DODAJ VEČ ŠTEVILK STRANK",
    loadMore: "Naloži več",
    toStaffDashboard: "Na nadzorno ploščo",
    toQuiz: "Na kviz",
    vouchers: "Vavčerji",
    exchangeVoucher: "Uveljavi kodo vavčerja",
    confirm: "Potrdi",
    sharePoints: "Deli točke",
    create: "Ustvari",
    update: "Posodobi",
    toBDrive: "V B-Drive",
    preview: "Predogled",
    clickHere: "Prikaži podrobnosti",
    setFilters: "Prosimo, nastavite <b>največ en filter na stolpec</b>",
    all: "Vse",
  },
  tooltips: {
    info: "Potrebujete pomoč? 01 92 64 88 50 0",
  },
  confirmation: {
    header: "Potrebna potrditev",
    message: "Ali želite izbrisati ta vnos?",
  },
  nav: {
    consents: "Soglasja",
    dashboard: "Nadzorna plošča",
    accountDashboard: "Nadzorna plošča",
    account: "Profil",
    mailbox: "Prejeta pošta",
    singleMailbox: "Sporočila",
    stammdaten: "Osnovni podatki",
    news_feeds: "Novice",
    pointsOverview: "Pregled točk",
    rewardsOverview: "Pregled točk",
    about: "O BS Plus",
    service_number: "Kontakt storitev",
    shop: "Trgovina z nagradami",
    salesPromotions: "Prodajne promocije",
    promotions: "Moj račun",
    shopCategory: "Trgovina z nagradami",
    productDetails: "Podrobnosti izdelka",
    userOrders: "Uporabniška naročila",
    shoppingCart: "Nakupovalna košarica",
    orderDelivery: "Naslov za dostavo",
    orderSummary: "Pregled naročila",
    orderComplete: "Naročilo dokončano",
    text_page: "Statična stran",
    staff: "Nadzorna plošča storitve",
    onlineTrainings: "Spletni treningi",
    trainings: "Treningi",
    training: "Trening",
    trainingForm: "Obrazec za trening",
    staffVouchers: "Vavčerji",
    wholesalerVouchers: "Vavčerji",
    brochure_prices: "Ceniki in brošure",
    investment: "Podpora nalozbam",
    media: "Mediji",
    medias: "Mediji",
    wholesaler: "Nadzorna plošča veleprodajalca",
    contact_service: "Kontaktne informacije in storitev",
    productInfo: "INFORMACIJE O IZDELKU",
    bDrive: "Slike izdelkov",
    touch_incentive: "Contact Touch Incentive",
    commitment_letter: "Pogoji sodelovanja",
    first_stop: "Bridgestone garancija za pnevmatike",
    payouts: "Payouts",
},
  breadcrumbs: {
    dashboard: "Nadzorna plošča",
    accountDashboard: "Nadzorna plošča",
    account: "Profil",
    mailbox: "Prejeta pošta",
    singleMailbox: "Sporočila",
    stammdaten: "Osnovni podatki",
    news_feeds: "Novice",
    pointsOverview: "Pregled točk",
    rewardsOverview: "Pregled točk",
    about: "O BS Plus",
    service_number: "Kontakt storitev",
    shop: "Trgovina z nagradami",
    salesPromotions: "Prodajne promocije",
    promotions: "Moj račun",
    shopCategory: "Trgovina z nagradami",
    productDetails: "Podrobnosti izdelka",
    userOrders: "Uporabniška naročila",
    shoppingCart: "Nakupovalna košarica",
    orderDelivery: "Naslov za dostavo",
    orderSummary: "Pregled naročila",
    orderComplete: "Naročilo dokončano",
    staff: "Nadzorna plošča storitve",
    onlineTrainings: "Spletni treningi",
    trainings: "Treningi",
    training: "Trening",
    trainingForm: "Obrazec za trening",
    staffVouchers: "Vavčerji",
    wholesalerVouchers: "Vavčerji",
    brochure_prices: "Ceniki in brošure",
    investment: "Podpora nalozbam",
    media: "Mediji",
    medias: "Mediji",
    wholesaler: "Nadzorna plošča veleprodajalca",
    contact_service: "Kontaktne informacije in storitev",
    productInfo: "INFORMACIJE O IZDELKU",
    bDrive: "Slike izdelkov",
    touch_incentive: "Contact Touch Incentive",
    commitment_letter: "Pogoji sodelovanja",
    first_stop: "Bridgestone garancija za pnevmatike",
    payouts: "Payouts",
},
  menu: {
    account: "Profil",
    plus: 'O Bridgestone <span class="text-danger">Plus</span>',
    salesSupport: "Prodajna podpora",
    mailbox: "Prejeta pošta",
    about: "O BS Plus",
    trainingAndCourses: "Treningi in tečaji",
    externalTraining: "Zunanji treningi",
    productInfo: "Informacije o izdelku",
    productBrochures: "Brošure izdelkov",
    priceLists: "Ceniki",
    price: "Cena",
    complaintForm: "Obrazec za pritožbo",
    sales_support: "Prodajna podpora",
    contact_service: "Kontaktne informacije in storitev",
    logOut: "Odjava",
    news: "Novice",
    news_feeds: "Novice",
    service_number: "Kontakt storitev",
    salesPromotions: "Prodajne promocije",
    shop: "Trgovina",
    onlineTrainings: "Spletni treningi",
    trainings: "Treningi",
    brochure_prices: "Ceniki in brošure",
    media: "Mediji",
    medias: "Mediji",
    stammdaten: "Osnovni podatki",
    preislisten: "Ceniki",
  },
  validation: {
    requiredField: "Polje obvezno",
  },
  sortBy: {
    default: "Razvrsti po",
    desc: "Razvrsti po: Najnovejše",
    asc: "Razvrsti po: Najstarejše",
    name: "Ime",
    date: "Datum",
    choiceBy: "Razvrsti",
  },
  month: {
    1: "januar",
    2: "februar",
    3: "marec",
    4: "april",
    5: "maj",
    6: "junij",
    7: "julij",
    8: "avgust",
    9: "september",
    10: "oktober",
    11: "november",
    12: "december"
  },
};


export default {
  messages,
};
